import { render, staticRenderFns } from "./workorderDcaChild.vue?vue&type=template&id=27b0128e&"
import script from "./workorderDcaChild.vue?vue&type=script&lang=js&"
export * from "./workorderDcaChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports